import { LazyLoadedStatesManager } from '../class/lazy-loaded-states-manager.class';
import { LazyLoadedStates } from '../interfaces/lazy-loaded-states.interface';

export const PresetManagementLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    slo: LazyLoadedStates,
    pg: LazyLoadedStates,
    viewPG: LazyLoadedStates,
    editPG: LazyLoadedStates
}>({
    base: {
        name: 'authenticated.preset-management',
        url: '/preset-management',
        abstract: true
    },
    slo: {
        name: 'authenticated.preset-management.slo',
        url: '/slo?schoolYear',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
        }
    },
    pg: {
        name: 'authenticated.preset-management.pg',
        url: '/spm',
        abstract: true
    },
    viewPG: {
        name: 'authenticated.preset-management.pg.view',
        url: '/view?orderBy&ascending',
        params: {
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    editPG: {
        name: 'authenticated.preset-management.pg.edit',
        url: '/edit/pg/:presetId/'
    }
},
    () => import('src/app/preset-management/preset-management.module').then((result: { PresetManagementModule: any }) => result.PresetManagementModule)
);
